import { render } from "./SocialDashboard.vue?vue&type=template&id=4b288c08"
import script from "./SocialDashboard.vue?vue&type=script&lang=js"
export * from "./SocialDashboard.vue?vue&type=script&lang=js"

import "./SocialDashboard.vue?vue&type=style&index=0&id=4b288c08&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__